module.exports = __webpack_public_path__ + "84b62eb4b6efe4c9b7ae2c51cc88c29a.jpg";